var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckoutCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0515 1.16271L4.33324 6.881L1.94826 4.49602C1.73104 4.2788 1.37937 4.2788 1.16271 4.49602C0.946042 4.71324 0.945487 5.0649 1.16271 5.28157L3.94047 8.05933C4.15769 8.27655 4.50935 8.27655 4.72602 8.05933L10.8371 1.94826C11.0543 1.73104 11.0543 1.37937 10.8371 1.16271C10.6199 0.946042 10.2682 0.945487 10.0515 1.16271Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutCheckmark);
export default __webpack_public_path__ + "static/media/checkout-checkmark.ada0d55fbbf29ccdaa59bb47a58431be.svg";
export { ForwardRef as ReactComponent };